import { createTestIds } from '@duke-hq/lib/createTestId';

export const testIds = createTestIds(
  'apps-admin-web-components-translations-OverrideEditor-EditVersionTimeline',
  ['heading', 'currentEntry', 'liveMarker', 'entry', 'baselineEntry', 'restore'],
);
